
import React from "react";
import * as react from "react";
import * as jotoTypes from "../../api/joto-types";
import {FormGroupInput, FormGroupTextarea, FormGroupSelect} from "../FormGroup";
import {Form} from "react-final-form";
import {
    UserMessage,
    validateShort,
    validateMedium,
    validateLong,
    validateUrl,
    validateforProfit,
    validateState,
    validateGermanZip, ValidationMessage
} from "../JotoUIUtils";


export interface ProjectFormProps {
    onSubmit: (values : jotoTypes.ProjectPublic) => any,
    initialValues : jotoTypes.ProjectPublic,
    title: string,
    userMessage? : UserMessage
    modal? : undefined | boolean
    onDelete?: (values : react.MouseEvent) => void,
}

function nameInputIsRequired(value : string | null) : ValidationMessage {
    if(!value || value.length < 3) {
        return "Ein Projekt braucht einen Namen der mindestens 3 Zeichen lang ist.";
    }
    return undefined;
}

function ProjectFormFragment() {
    return <>
            <FormGroupInput    prefix="edit-project-edit-form" valuePropertyKey="name"            label="Name"                placeholder="Dein Projektname"                     validate={(i)=> validateShort(i) || nameInputIsRequired(i)}/>
            <FormGroupTextarea prefix="edit-project-edit-form" valuePropertyKey="abstract"        label="Kurzbeschreibung"    placeholder="Kurzbeschreibung deines Projekts"     validate={validateMedium}                                  />
            <FormGroupTextarea prefix="edit-project-edit-form" valuePropertyKey="description"     label="Projektbeschreibung" placeholder="Detailbeschreibung deines Projekts"   validate={validateLong}                                    />    
            <FormGroupInput    prefix="edit-project-edit-form" valuePropertyKey="pictureURL"      label="Bild URL"            placeholder="Url zu einem Projektbild"             validate={validateUrl}                                     subtext="max. (1000px x 1000px)"    infotext="Füge einen Bildlink hinzu. Einen Bildlink für ein lokales Bild kannst du beispielsweise mithilfe von Dropbox oder Googledrive erstellen." />
            <FormGroupInput    prefix="edit-project-edit-form" valuePropertyKey="zip_code"        label="PLZ"                 placeholder="Postleitzahl"                         validate={validateGermanZip}                               />
            <FormGroupInput    prefix="edit-project-edit-form" valuePropertyKey="city"            label="Ort"                 placeholder="Ort"                                  validate={validateShort}                                   />
            <FormGroupSelect    prefix="edit-project-edit-form" valuePropertyKey="state"           label="Projektstatus"      placeholder=""                                     validate={validateState}                                   labelList={["1-Idee", "2-Planung", "3-Durchführung"]}   valueList={["1", "2", "3"]}/>
            <FormGroupSelect   prefix="edit-project-edit-form" valuePropertyKey="forProfit"       label="Profitorientiert"    placeholder="Nein oder Ja"                         validate={validateforProfit}                               subtext="Willst Du mit Deinem Projekt Geld verdienen?"  labelList={["Nein", "Ja"]} valueList={["no", "yes"]}/>
        </>;
}

const ProjectForm : React.FunctionComponent<ProjectFormProps> = (props) => {
    return <Form onSubmit={props.onSubmit} initialValues={props.initialValues}>
        {({ handleSubmit, submitting }) => {

            let alert_class = 'alert-success d-none'; // 'alert-warning', 'alert-danger';
            let alert_text = '&nbsp;';
            if(submitting) {
                alert_class = 'alert-warning';
                alert_text = '... wird gespeichert ...'
            } else {
                alert_class = 'alert-success d-none'; // 'alert-warning', 'alert-danger';
                alert_text = '&nbsp;'
            }

            return <form onSubmit={handleSubmit}>
                {
                    props.modal ? <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">{props.title}</h5>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                            </div>
                            <div className="modal-body">
                                {ProjectFormFragment()}
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" data-dismiss="modal">Schließen</button>
                                <button type='submit' className="btn btn-dark" disabled={submitting} >Speichern</button>
                                {props.onDelete ? <button type='button' className="btn btn-danger ml-2" onClick={props.onDelete}>Löschen</button> : null }
                            </div>
                            <div className={"alert mt-2 " + alert_class} role="alert">
                                {alert_text}
                            </div>
                        </div>
                        :
                        <>
                            {ProjectFormFragment()}
                            <button type='submit' className="btn btn-dark" disabled={submitting}>Speichern</button><button type='button' className="btn btn-danger ml-2" onClick={props.onDelete}>Löschen</button>
                            <div className={"alert mt-2 " + alert_class} role="alert">
                                {alert_text}
                            </div>
                        </>
                }
            </form>;
        }}
    </Form>
};

export {ProjectForm, validateShort, validateLong, validateUrl};
